module.exports = __webpack_public_path__ + "static/img/1.3d32ef1.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/qlxj/1.png
// module id = yPSl
// module chunks = 5